// import jQuery from 'CommonScripts/jquery-1.10.2';

(function (window, document, $) {
     
    $(document).ready(function () {            

        //$.components.registerComponent('section.mosaic-gallery-spot', function ($root) {
            var $root = document.querySelectorAll('section.mosaic-gallery-spot');
            $root = $($root);
            var gridGallery = {
                dom: {
                    gridItems: $root.find('.grid-item')
                },
                set: {
                    imageReplacementClass: 'grid-item-img-replacement',
                    itemMediaSelector: '.grid-item-media',
                    fadeInDelay: 250,
                    fadeOutDelay: 250,
                    hideItemsDelay: 350,
                    hrefData: 'grid-href',
                    imgData: 'grid-image',
                    stepLoadDelay: 100,
                    hideItemsTimeoutId: 0
                },
                fn: {
                    preload: function () {
                        $dom.gridItems.each(function () {
                            if ($(this).closest(".grid-container").is(":visible")) {
                                $('<img/>')[0].src = $(this).data($set.imgData);
                                if ($(this).attr('data-' + $set.hrefData).length > 0) {
                                } else { $(this).css("cursor", "default"); }
                            }
                        });
                    },
                    hideImageReplacements: function () {
                        $dom.gridItems.each(function () {
                            $(this).find('.' + $set.imageReplacementClass).fadeOut($set.fadeOutDelay, function () {
                                $(this).remove();
                            });
                        });
                    },
                    hideItems: function () {
                        $set.hideItemsTimeoutId = setTimeout($fn.hideImageReplacements, $set.hideItemsDelay);
                    },
                    showItem: function () {
                        if ($set.hideItemsTimeoutId) {
                            clearTimeout($set.hideItemsTimeoutId);
                        }

                        var $image = $('<img/>').addClass($set.imageReplacementClass).attr({ src: $(this).data($set.imgData) });

                        $dom.gridItems.each(function (step) {
                            var $this = $(this);

                            var $imageCopy = $image.clone();
                            $this.find($set.itemMediaSelector).append($imageCopy);
                            $imageCopy.delay(step * $set.stepLoadDelay).fadeIn($set.fadeInDelay);
                        });
                    },
                    followLink: function () {
                        if ($(this).attr('data-' + $set.hrefData).length > 0) {
                            window.location = $(this).attr('data-' + $set.hrefData);
                        }
                    }
                }
            },
            /* Add quick access variables to be used in local function
             * Keep main variable name in case it needs to be shared with other JS files
             */
            $dom = gridGallery.dom,
            $set = gridGallery.set,
            $fn = gridGallery.fn;

            $fn.preload();

            $dom.gridItems.on({
                mouseenter: $fn.showItem,
                mouseleave: $fn.hideItems,
                click: $fn.followLink
            });
       // });

    });

})(window, document, jQuery);